export const TIME_INTERVAL_TYPES: string[] = ['DAILY', 'WEEKLY', 'MONTHLY'];